import { useCallback, useContext, useEffect, useState } from 'react';
import { RewardsCoordinatorContext } from '../RewardsCoordinatorContext';
import type { RewardsState } from '../RewardsCoordinator';

export function useRewardsState(): RewardsState & {
  refreshProfile: () => void;
  refreshCatalogue: () => void;
  dismissAffordability: () => void;
} {
  const coordinator = useContext(RewardsCoordinatorContext);
  if (!coordinator) {
    throw new Error('useRewardsState must be used within a RewardsCoordinatorProvider');
  }

  const [state, setState] = useState<RewardsState>(coordinator.getState());

  useEffect(() => {
    setState(coordinator.getState());
    return coordinator.subscribe(setState);
  }, [coordinator]);

  const refreshProfile = useCallback(() => {
    coordinator.refreshProfile();
  }, [coordinator]);

  const refreshCatalogue = useCallback(() => {
    coordinator.refreshCatalogue();
  }, [coordinator]);

  const dismissAffordability = useCallback(() => {
    coordinator.dismissAffordability();
  }, [coordinator]);

  return { ...state, refreshProfile, refreshCatalogue, dismissAffordability };
}
